import React, { FC } from 'react'
import { Text } from '@moonpig/launchpad-components'
import { IconSystemPlusFilled } from '@moonpig/launchpad-assets'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { colorValue } from '@moonpig/launchpad-theme'

const SelectNewButton = styled.button`
  ${s({
    padding: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    border: '2px dashed',
    borderColor: 'colorBorder03',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 2,
    color: 'colorInteractionSelectedState',
    bgcolor: 'colorBackground01',
  })}
  cursor: pointer;

  &:hover {
    background-color: ${colorValue('colorBackgroundSelectedState')};
    border-color: ${colorValue('colorBackgroundSelectedState')};
  }

  &:focus-visible {
    background-color: ${colorValue('colorBackgroundSelectedState')};
    border-color: ${colorValue('colorInteractionSelectedState')};
    outline: 2px solid ${colorValue('colorInteractionFocusIndicator')};
    outline-offset: 2px;
  }
`

type SelectNewTileProps = {
  label: string
  onClick: () => void
}

export const SelectNewTile: FC<SelectNewTileProps> = ({ label, onClick }) => (
  <SelectNewButton
    type="button"
    onClick={onClick}
    data-testid="mp-select-card-select-new"
  >
    <IconSystemPlusFilled width={32} height={32} />
    <Text mt={3} mb={0} typography="typeButtonLabel">
      {label}
    </Text>
  </SelectNewButton>
)
